import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8259dbaa = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _fa763268 = () => interopDefault(import('../../../pages/cookies.tsx' /* webpackChunkName: "pages/cookies" */))
const _d184ad72 = () => interopDefault(import('../../../pages/dla-potrzebujacych.vue' /* webpackChunkName: "pages/dla-potrzebujacych" */))
const _80ffc552 = () => interopDefault(import('../../../pages/dodaj-podopiecznego.vue' /* webpackChunkName: "pages/dodaj-podopiecznego" */))
const _3e2408d4 = () => interopDefault(import('../../../pages/index-old.vue' /* webpackChunkName: "pages/index-old" */))
const _c0ac0aec = () => interopDefault(import('../../../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _6c96dc47 = () => interopDefault(import('../../../pages/nota.tsx' /* webpackChunkName: "pages/nota" */))
const _d3ec85d4 = () => interopDefault(import('../../../pages/oswiadczenie-o-rezygnacji-z-udzialu-w-programie.tsx' /* webpackChunkName: "pages/oswiadczenie-o-rezygnacji-z-udzialu-w-programie" */))
const _1da115c4 = () => interopDefault(import('../../../pages/partnerzy.tsx' /* webpackChunkName: "pages/partnerzy" */))
const _21cdae5e = () => interopDefault(import('../../../pages/podopieczni.vue' /* webpackChunkName: "pages/podopieczni" */))
const _22f6f528 = () => interopDefault(import('../../../pages/polityka-prywatnosci.tsx' /* webpackChunkName: "pages/polityka-prywatnosci" */))
const _119e48e8 = () => interopDefault(import('../../../pages/pomoc.vue' /* webpackChunkName: "pages/pomoc" */))
const _8c8d478e = () => interopDefault(import('../../../pages/regulamin.tsx' /* webpackChunkName: "pages/regulamin" */))
const _0f4bd36c = () => interopDefault(import('../../../pages/resetowanie-hasla.vue' /* webpackChunkName: "pages/resetowanie-hasla" */))
const _0526a94b = () => interopDefault(import('../../../pages/rezygnacja.tsx' /* webpackChunkName: "pages/rezygnacja" */))
const _2ed352f4 = () => interopDefault(import('../../../pages/rozszerzenie.vue' /* webpackChunkName: "pages/rozszerzenie" */))
const _1c04de20 = () => interopDefault(import('../../../pages/sklepy.vue' /* webpackChunkName: "pages/sklepy" */))
const _06e5777d = () => interopDefault(import('../../../pages/statut-fundacji.tsx' /* webpackChunkName: "pages/statut-fundacji" */))
const _6b92f2d0 = () => interopDefault(import('../../../pages/test.vue' /* webpackChunkName: "pages/test" */))
const _a75a1774 = () => interopDefault(import('../../../pages/wtyczka-po-instalacji.vue' /* webpackChunkName: "pages/wtyczka-po-instalacji" */))
const _925865f2 = () => interopDefault(import('../../../pages/zalogowany-opiekun.vue' /* webpackChunkName: "pages/zalogowany-opiekun" */))
const _18c2e72c = () => interopDefault(import('../../../pages/zalogowany-pomagajacy.vue' /* webpackChunkName: "pages/zalogowany-pomagajacy" */))
const _1b06747c = () => interopDefault(import('../../../pages/zaloguj.vue' /* webpackChunkName: "pages/zaloguj" */))
const _50244f5d = () => interopDefault(import('../../../pages/zgloszenie-braku-transakcji.vue' /* webpackChunkName: "pages/zgloszenie-braku-transakcji" */))
const _4c8288c8 = () => interopDefault(import('../../../pages/zgoda.tsx' /* webpackChunkName: "pages/zgoda" */))
const _3c195e86 = () => interopDefault(import('../../../pages/zmiana-hasla.vue' /* webpackChunkName: "pages/zmiana-hasla" */))
const _d51ff088 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6dacb6c6 = () => interopDefault(import('../../../pages/konto/rejestracja/aktywacja/_activateAccountToken.vue' /* webpackChunkName: "pages/konto/rejestracja/aktywacja/_activateAccountToken" */))
const _0d6fc6b2 = () => interopDefault(import('../../../pages/konto/rejestracja/potwierdzenie-email/_confirmEmailToken.vue' /* webpackChunkName: "pages/konto/rejestracja/potwierdzenie-email/_confirmEmailToken" */))
const _85c71e3a = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _1d3e0129 = () => interopDefault(import('../../../pages/podopieczny/_slug.vue' /* webpackChunkName: "pages/podopieczny/_slug" */))
const _358f3f94 = () => interopDefault(import('../../../pages/rejestracja-pomagajacy/_childSlug.vue' /* webpackChunkName: "pages/rejestracja-pomagajacy/_childSlug" */))
const _55528fe4 = () => interopDefault(import('../../../pages/sklep/_shopId/przejdz.vue' /* webpackChunkName: "pages/sklep/_shopId/przejdz" */))
const _01ed29b0 = () => interopDefault(import('../../../pages/haslo/_uid/_token.vue' /* webpackChunkName: "pages/haslo/_uid/_token" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _8259dbaa,
    name: "blog"
  }, {
    path: "/cookies",
    component: _fa763268,
    name: "cookies"
  }, {
    path: "/dla-potrzebujacych",
    component: _d184ad72,
    name: "dla-potrzebujacych"
  }, {
    path: "/dodaj-podopiecznego",
    component: _80ffc552,
    name: "dodaj-podopiecznego"
  }, {
    path: "/index-old",
    component: _3e2408d4,
    name: "index-old"
  }, {
    path: "/kontakt",
    component: _c0ac0aec,
    name: "kontakt"
  }, {
    path: "/nota",
    component: _6c96dc47,
    name: "nota"
  }, {
    path: "/oswiadczenie-o-rezygnacji-z-udzialu-w-programie",
    component: _d3ec85d4,
    name: "oswiadczenie-o-rezygnacji-z-udzialu-w-programie"
  }, {
    path: "/partnerzy",
    component: _1da115c4,
    name: "partnerzy"
  }, {
    path: "/podopieczni",
    component: _21cdae5e,
    name: "podopieczni"
  }, {
    path: "/polityka-prywatnosci",
    component: _22f6f528,
    name: "polityka-prywatnosci"
  }, {
    path: "/pomoc",
    component: _119e48e8,
    name: "pomoc"
  }, {
    path: "/regulamin",
    component: _8c8d478e,
    name: "regulamin"
  }, {
    path: "/resetowanie-hasla",
    component: _0f4bd36c,
    name: "resetowanie-hasla"
  }, {
    path: "/rezygnacja",
    component: _0526a94b,
    name: "rezygnacja"
  }, {
    path: "/rozszerzenie",
    component: _2ed352f4,
    name: "rozszerzenie"
  }, {
    path: "/sklepy",
    component: _1c04de20,
    name: "sklepy"
  }, {
    path: "/statut-fundacji",
    component: _06e5777d,
    name: "statut-fundacji"
  }, {
    path: "/test",
    component: _6b92f2d0,
    name: "test"
  }, {
    path: "/wtyczka-po-instalacji",
    component: _a75a1774,
    name: "wtyczka-po-instalacji"
  }, {
    path: "/zalogowany-opiekun",
    component: _925865f2,
    name: "zalogowany-opiekun"
  }, {
    path: "/zalogowany-pomagajacy",
    component: _18c2e72c,
    name: "zalogowany-pomagajacy"
  }, {
    path: "/zaloguj",
    component: _1b06747c,
    name: "zaloguj"
  }, {
    path: "/zgloszenie-braku-transakcji",
    component: _50244f5d,
    name: "zgloszenie-braku-transakcji"
  }, {
    path: "/zgoda",
    component: _4c8288c8,
    name: "zgoda"
  }, {
    path: "/zmiana-hasla",
    component: _3c195e86,
    name: "zmiana-hasla"
  }, {
    path: "/",
    component: _d51ff088,
    name: "index"
  }, {
    path: "/konto/rejestracja/aktywacja/:activateAccountToken?",
    component: _6dacb6c6,
    name: "konto-rejestracja-aktywacja-activateAccountToken"
  }, {
    path: "/konto/rejestracja/potwierdzenie-email/:confirmEmailToken?",
    component: _0d6fc6b2,
    name: "konto-rejestracja-potwierdzenie-email-confirmEmailToken"
  }, {
    path: "/blog/:slug",
    component: _85c71e3a,
    name: "blog-slug"
  }, {
    path: "/podopieczny/:slug?",
    component: _1d3e0129,
    name: "podopieczny-slug"
  }, {
    path: "/rejestracja-pomagajacy/:childSlug?",
    component: _358f3f94,
    name: "rejestracja-pomagajacy-childSlug"
  }, {
    path: "/sklep/:shopId?/przejdz",
    component: _55528fe4,
    name: "sklep-shopId-przejdz"
  }, {
    path: "/haslo/:uid?/:token?",
    component: _01ed29b0,
    name: "haslo-uid-token"
  }, {
    path: "/konto/zaloguj",
    redirect: {"name":"zaloguj"}
  }, {
    path: "/podopieczni/:slug",
    redirect: (to) => {
      return {
        name: 'podopieczny-slug',
        params: {
          slug: to.params.slug
        }
      };
    }
  }, {
    path: "/%26*",
    redirect: {"name":"index"}
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
